import VideoPlayer from '@/components/VideoPlayer';
import { PreviewAnswerPopover } from './PreviewAnswerPopover';

interface VideoRecord {
  src?: string | null;
  width: number;
  poster?: string | null;
}

export default function VideoReplay({ src, width, poster }: VideoRecord) {
  return (
    <VideoPlayer
      src={src ?? ''}
      width={width + 'px'}
      style={{
        position: 'relative',
        zIndex: 10,
        overflow: 'unset'
      }}
      type="video/mp4"
      autoPlay={false}
      // Real poster captured from the live preview at record start.
      poster={poster}
      PlayIcon={<PreviewAnswerPopover />}
      ReplayIcon={<PreviewAnswerPopover />}
    ></VideoPlayer>
  );
}
